// extracted by mini-css-extract-plugin
export var aircallIframe = "_cv-3";
export var fabContainer = "_cv-5";
export var fabRinging = "_cv-6";
export var loadingOverlay = "_cv-4";
export var pulse = "_cv-7";
export var widgetContent = "_cv-2";
export var widgetPanel = "_cv-0";
export var widgetPanelExpanded = "_cv-1";